import styled from '@emotion/styled';

export const ResultsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  marginBottom: 10,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 8
  }
}));

export const ResultsControls = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  justifyContent: 'flex-end'
}));
